<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            LOS RETRATOS <br>
            DE LA INMIGRACIÓN <br>
            DEL SIGLO XIX <br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio11/retratos-inmigracion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio11/retratos-inmigracion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio11/retratos-inmigracion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    DURANTE EL SIGLO XIX, SE DIO UN FLUJO MIGRATORIO TRANSOCEÁNICO HACIA EL PERÚ QUE RESPONDÍA A POLÍTICAS 
                    ECONÓMICAS Y SOCIALES. EL <span class="fontMS500Italic">BOOM</span> DEL COMERCIO DEL GUANO (1850-1880) 
                    ATRAJO A INGLESES, FRANCESES, ALEMANES E ITALIANOS QUE VIERON LA POSIBILIDAD DE REALIZACIÓN EMPRESARIAL, 
                    UNOS LIGADOS A CASAS COMERCIALES EN LA CAPITAL Y OTROS, A TRAVÉS DE LA INSTALACIÓN DE SUS PROPIOS NEGOCIOS 
                    CONFORMARON UNA RED COMERCIAL <br>A LO LARGO DEL TERRITORIO.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    La mayor inmigración fue la estimulada desde el Estado para la contratación de ciudadanos chinos como mano de 
                    obra para labores agrícolas en las haciendas de la costa norte y sur. Por otro lado, la colonización del territorio 
                    nacional, sobre todo el gran territorio amazónico, fue proyectada desde las élites gobernantes bajo la consigna 
                    que su progreso y desarrollo debería llevarse a cabo con migrantes europeos. Aunque dichos esfuerzos estatales no 
                    prosperaron, se recibió un grupo de trabajadores del campo austriacos y alemanes en Oxapampa (Pasco) e italianos 
                    en Chanchamayo (Junín). La importante inmigración japonesa al darse en 1899, se ha considerado como parte del siglo XX.
                    <br><br>
                    Se presenta una aproximación al complejo proceso inmigratorio a través de retratos de los extranjeros afincados en el Perú, 
                    sus familias y descendientes, entre 1880 y 1930, seleccionadas de la colección fotográfica Courret de la Biblioteca Nacional 
                    del Perú, acervo visual de más de 50 mil imágenes procedentes de negativos en vidrio y acetato que son conservados, restaurados 
                    y digitalizados para el estudio de nuestra historia.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO_CH">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INMIGRACIÓN CHINA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br><br>
                    LA INMIGRACIÓN CHINA EN EL PERÚ SE DIO ENTRE 1850 Y 1875 IMPULSADA POR LA PODEROSA E INFLUYENTE CLASE TERRATENIENTE 
                    COSTEÑA QUE NECESITABA BRACEROS PARA EL TRABAJO AGRÍCOLA.
                    <br>
                </p>
                <p class="fontMS100 text-justify text-white font-24">
                    <br>
                    En 1849, el presidente Ramón Castilla decreta la Ley General de Emigración, llamada también Ley china, 
                    en la que se otorgaba 30 pesos por cada empresario que trajera 50 colonos desde China. En 1853, ingresaron 
                    2 mil 516 chinos al país como mano de obra para las haciendas de la costa, lo que representó una gran demanda 
                    para labores agrícolas. Los chinos llegaban contratados para laborar en el campo, bajo condiciones de servidumbre. 
                    La mayoría de los inmigrantes chinos eran originarios de la ciudad de Cantón, provincia sureña de Guandong. 
                    En 1856, Castilla suprimió el arribo de colonos chinos, pero los hacendados necesitaban mano de obra para la 
                    demanda de algodón e hicieron que el Congreso aprobará una nueva ley en 1861 para continuar con su arribo. 
                    Se estima que 90 mil <span class="fontMS100Italic">culís</span>, designación que se daba a los trabajadores 
                    de origen oriental, llegaron al Perú entre 1849 y 1875 para laborar en las plantaciones de algodón y azúcar. 
                    Asimismo, unos 10 mil trabajaron arribaron para trabajar en las islas guaneras y en la construcción de las vías 
                    férreas que impulsaba el Estado.
                    <br><br>
                    Al término de sus contratos laborales, una parte de los ciudadanos chinos decidió emprender negocios independientes. 
                    En Lima se conformó el barrio chino e instituciones ligadas a la colonia asiática. De igual modo, alrededor de 1884, 
                    una importante colonia china se instaló en la ciudad amazónica de Iquitos para dedicarse al comercio y negocios vinculados 
                    a la explotación del caucho.
                </p>
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2532" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_002.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Liu chin Ham<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2570" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_003.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Liu<br>
                                        1885
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/39162" target="_blank" style="color: black;">

                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_004.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Alejandro Chong<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/1805" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_005.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Manuel de la Cruz<br>
                                        1893
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2765" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_006.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Young<br>
                                        1894
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2191" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_007.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Jo San Jon<br>
                                        1899
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/39163" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Chun Yen<br>
                                        1902
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2188" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_009.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pou Heng Chang<br>
                                        1903
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/4036" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_010.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Jorge Lay y esposa<br>
                                        1911
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2952" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_011.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Chan Kam<br>
                                        1915
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/27554" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_012.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanos Tong<br>
                                        1928
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/39157" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_013.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Emma Fung<br>
                                        1929
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2532" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_002.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Liu chin Ham<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2570" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_003.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Liu<br>
                                        1885
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/39162" target="_blank" style="color: black;">

                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_004.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Alejandro Chong<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/1805" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_005.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Manuel de la Cruz<br>
                                        1893
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2191" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_007.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Jo San Jon<br>
                                        1899
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2191" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_007.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Jo San Jon<br>
                                        1899
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/39163" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Chun Yen<br>
                                        1902
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2188" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_009.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pou Heng Chang<br>
                                        1903
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/4036" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_010.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Jorge Lay y esposa<br>
                                        1911
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2952" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_011.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Chan Kam<br>
                                        1915
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/27554" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_012.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanos Tong<br>
                                        1928
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/39157" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_013.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Emma Fung<br>
                                        1929
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <div class="row p2">
                    <img width="100%" src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_LINEA2.jpg">
                </div>

                <div class="row p2">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INMIGRACIÓN ITALIANA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    HACIA LA MITAD DEL SIGLO XIX, LLEGARON LOS MIGRANTES ITALIANOS, QUIENES PROVENÍAN MAYORITARIAMENTE DE LA REGIÓN DE 
                    LIGURIA, LLEGARON A TRAVÉS DE LAS LÍNEAS MERCANTES GENOVESAS Y SE ASENTARON EN LAS ZONAS URBANAS Y COSTERAS, PARA 
                    LUEGO DISTRIBUIRSE AL INTERIOR DEL PAÍS, DEDICÁNDOSE AL COMERCIO, YA SEA COMO PROPIETARIOS O ADMINISTRADORES DE NEGOCIOS 
                    DE VENTA DE ALIMENTOS Y BEBIDAS O COMO ARTESANOS. HACIA 1860, YA ERA LA SEGUNDA COLONIA EUROPEA MÁS NUMEROSA EN LIMA Y EL 
                    CALLAO, CON 5 MIL INDIVIDUOS.
                    <br><br>
                </p>
                <p class="text-justify text-white font-24">
                    Entre 1873 y 1875, como parte de la política de incentivo migratorio dictada por el gobierno de Manuel Pardo, doscientos inmigrantes 
                    italianos se establecieron en la colonia agrícola de Chanchamayo, bajo ofrecimientos de proporcionarles tierras e implementos de cultivo, 
                    los cuales fueron incumplidos del Estado. Después de la Guerra del Pacífico, los precios del café se elevaron, lo que hizo que aumentara 
                    la población, a 2 mil habitantes, en su mayoría de origen italiano.
                    <br><br>
                </p>
                <p class="text-justify text-white font-24">
                    Hacia 1876, la colonia italiana era la segunda más numerosa en el Perú con 7 mil miembros y había conformado instituciones como la Beneficencia 
                    Italiana (1862), la compañía de bomberos (la primera Bomba Roma, en 1868), el colegio Santa Margarita (1872), el Banco Italiano (1889), entre otras.
                    <br><br>
                    A finales del siglo XIX, resalta la participación italiana en la actividad minera en la Sierra Central (Junín, Huánuco, Huancavelica y Pasco).
                    <br><br>
                </p>
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/31076" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_014.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanos Puccio<br>
                                        1879
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/29489" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Esteban Ferrando<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2746" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Luigi Dagnino Cevasco e hija<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/12871" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_017.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        María E. Tenderini<br>
                                        1882
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/17353" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Virgilio Dall’Orso Descalzi<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/3146" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_019.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Bartolomé Costa y familia<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/45229" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_020.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Juan Piaggio<br>
                                        1887
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/40075" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_021.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Giacometti Marzano de Visconti y familia<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/35638" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_022.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Inés Canevaro<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/47367" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_023.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Giovanni Battista Agnoli (de pie superior izquierda) y amigos<br>
                                        1897
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/53654" target="_blank" style="color: black;">

                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_024.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanas Rainusso<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/2921" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_025.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Leopoldo Bracale<br>
                                        1892
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <br>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/77785" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_026.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Juan Borasino<br>
                                        1913
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/27409" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_027.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Señoritas Larco Vásquez<br>
                                        1919
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <br>
                    </div>
                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/31076" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_014.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanos Puccio<br>
                                        1879
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/29489" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Esteban Ferrando<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2746" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Luigi Dagnino Cevasco e hija<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/12871" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_017.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        María E. Tenderini<br>
                                        1882
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/17353" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Virgilio Dall’Orso Descalzi<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/3146" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_019.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Bartolomé Costa y familia<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/45229" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_020.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Juan Piaggio<br>
                                        1887
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/40075" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_021.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Giacometti Marzano de Visconti y familia<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/35638" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_022.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Inés Canevaro<br>
                                        1888
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/47367" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_023.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Giovanni Battista Agnoli (de pie superior izquierda) y amigos<br>
                                        1897
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/53654" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_024.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Hermanas Rainusso<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/2921" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_025.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Leopoldo Bracale<br>
                                        1892
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/77785" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_026.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Juan Borasino<br>
                                        1913
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/27409" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_027.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Señoritas Larco Vásquez<br>
                                        1919
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="row p2">
                    <img width="100%" src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_LINEA2.jpg">
                </div>
                <div class="row p2">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INMIGRACIÓN FRANCESA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    EN EL SIGLO XIX, LA EXPLOTACIÓN INDUSTRIAL DE MATERIAS PRIMAS ATRAJO AL PERÚ CAPITALES Y MANO DE OBRA EUROPEA. 
                    LOS GOBIERNOS DE CASTILLA, BALTA Y PARDO EMPRENDIERON UNA POLÍTICA DE GRANDES OBRAS. ES EN ESTE ESCENARIO, QUE 
                    LOS PROFESIONALES FRANCESES FUERON SOLICITADOS CON FRECUENCIA PARA LA CONSTRUCCIÓN DE INSTALACIONES URBANAS E 
                    INDUSTRIALES.
                    <br><br>
                </p>
                <p class="text-justify text-white font-24">
                    Hacia la segunda mitad del siglo XIX, la colonia francesa en el Perú se convirtió numéricamente, en una de las más 
                    importantes del país, después de los italianos y los ingleses. En 1872, el encargado de negocios de Francia en el Perú 
                    dirigió a su país información sobre el número de sus compatriotas en Lima y el Callao, así como en otras ciudades como 
                    Trujillo o Arequipa. El número total de franceses que habitaban en el Perú en ese año, se estimó en 2 mil 625: 1 mil 
                    734 hombres, 586 mujeres y 305 niños.
                    <br><br>
                </p>
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/53408" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_028.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Bomberos franceses<br>
                                        1881
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/40331" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_029.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Savé<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/51401" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_030.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        María Virginia Lacroix Cisneros<br>
                                        1887
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/57347" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_031.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Nugent<br>
                                        Ca. 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/47277" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_032.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Isabel Dupont de Bohl<br>
                                        1892
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/51173" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_033.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Claudio Víctor Boursot e hijos<br>
                                        1896
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/76780" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_034.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Elena de Benoit y novio<br>
                                        1900
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/65278" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_035.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Francisco Bussalleu y familia<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/39429" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_036.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Gustavo Dreyfus<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/27836" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_037.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pedro R. Labrousse<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/60201" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_038.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pedro Blondet Moyano y esposa<br>
                                        1912
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/45903" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_039.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Crousillat Blanco<br>
                                        1913
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/53408" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_028.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Bomberos franceses<br>
                                        1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/40331" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_029.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Savé<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/51401" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_030.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        María Virginia Lacroix Cisneros<br>
                                        1887
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/57347" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_031.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Nugent<br>
                                        Ca. 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/47277" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_032.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Isabel Dupont de Bohl<br>
                                        1892
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/51173" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_033.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Claudio Víctor Boursot e hijos<br>
                                        1896
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/76780" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_034.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Elena de Benoit y novio<br>
                                        1900
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/65278" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_035.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Francisco Bussalleu y familia<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/39429" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_036.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Gustavo Dreyfus<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/27836" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_037.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pedro R. Labrousse<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/60201" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_038.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Pedro Blondet Moyano y esposa<br>
                                        1912
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/45903" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_039.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José Crousillat Blanco<br>
                                        1913
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoGris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify font-28">
                    “EN 2019 EL NÚMERO DE MIGRANTES INTERNACIONALES (PERSONAS QUE RESIDEN EN UN PAÍS DISTINTO AL DE
                    NACIMIENTO) ALCANZÓ LOS 272 MILLONES EN TODO EL MUNDO, ESTIMANDO QUE 38 MILLONES SON NIÑOS”.
                </p>
                <p class="text-justify font-28 text-right">
                    <a class="fontMS500Italic hipText" href="https://iamamigrant.org/es" target="_blank"
                        style="color: black;">
                        ORGANIZACIÓN INTERNACIONAL PARA LAS MIGRACIONES DE LAS NACIONES UNIDAS
                    </a>
                </p>
                <img id="img_rotate" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_IN">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row p2">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INMIGRACIÓN INGLESA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    LA INMIGRACIÓN INGLESA SE DIO COMO CONSECUENCIA DE LA EXPANSIÓN COMERCIAL DEL IMPERIO BRITÁNICO. FUE A INICIOS DEL PERÍODO REPUBLICANO PERUANO, 
                    QUE SE DIO UNA MIGRACIÓN DE CIUDADANOS INGLESES LIGADOS A CASAS COMERCIALES Y COMPAÑÍAS MERCANTILES, FINANCIERAS O PORTUARIAS, EN CALIDAD DE EMPLEADOS 
                    O REPRESENTANTES.
                    <br><br>
                </p>
                <p class="text-justify font-24">
                    Hacia 1853 habían desembarcado más de 300 irlandeses para laborar en las haciendas instaladas en el Perú, pero la mayoría partiría del Perú al 
                    no encontrar condiciones adecuadas para su desarrollo. En tanto, los capitales británicos instalaron en el país industrias relacionadas a la 
                    manufactura textil, los ferrocarriles, la banca y seguros.
                    <br><br>
                    En 1876 se contabilizó 3 mil 379 británicos a lo largo del Perú.
                    <br>
                </p>
                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class=" col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/55103" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_040.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Higginson<br>
                                        Ca. 1885
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/34238" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_041.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Gallagher<br>
                                        Ca. 1885
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/4480" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_042.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Benjamín Collins<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/3247" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_043.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Enrique Cox Doray<br>
                                        1907
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/49920" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_044.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ricardo Thorne<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/55904" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_045.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        J. Cuningham<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/14768" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_046.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        James Graham<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/10865" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_047.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ricardo Higginson y hermano<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/27975" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_048.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Daukins<br>
                                        1894
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/28823" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_049.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Lily Miller<br>
                                        1922
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/47277" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_050.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Guillermo Billinghurst<br>
                                        1919
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55103" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_040.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Higginson<br>
                                        Ca. 1885
                                    </p>
                                </div>
                            </a>

                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/34238" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_041.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Gallagher<br>
                                        Ca. 1885
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/4480" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_042.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Benjamín Collins<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/3247" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_043.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Enrique Cox Doray<br>
                                        1907
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/49920" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_044.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ricardo Thorne<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55904" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_045.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        J. Cuningham<br>
                                        1910
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/14768" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_046.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        James Graham<br>
                                        1880
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/10865" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_047.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ricardo Higginson y hermano<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/27975" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_048.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Daukins<br>
                                        1894
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/28823" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_049.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Lily Miller<br>
                                        1922
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/47277" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_050.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Guillermo Billinghurst<br>
                                        1919
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <br>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <img width="100%" src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_LINEA2.jpg">
        </div>
    </div>
</div>

<div class="fondoBlanco_AL">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row p2">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INMIGRACIÓN ALEMANA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    EN LA DÉCADA DE 1850 ARRIBARON AL PERÚ 1 MIL 096 ALEMANES. HACIA 1853 SE INTENTÓ INICIAR LA COLONIZACIÓN DE LORETO 
                    Y LAS TIERRAS DE LA SELVA BAJA CON INMIGRANTES ALEMANES PERO LA INICIATIVA NO PROSPERÓ.
                    <br><br>
                </p>
                <p class="text-justify font-24">
                    En 1855, se emitió un decreto supremo en el cual se establecía que el gobierno se encargaría del transporte de los colonos 
                    hasta el Callao, facilitaría su desplazamiento a la selva y, durante tres meses, suministraría víveres, semillas y útiles. 
                    En 1857, el gobierno inició la construcción de un camino desde la ciudad de Cerro de Pasco hacia el valle de Pozuzo (Oxapampa, Pasco), 
                    pero quedó inconcluso. Ese año, doscientos austriacos (tiroleses) se unieron a cien alemanes de la inmigración anterior e iniciaron 
                    su travesía hasta la selva alta. Dos años después, en 1859, llegaron 170 alemanes y austriacos para fundar la colonia de Pozuzo. 
                    El terreno agreste fue convertido en agrícola. En 1868, se sumaron trescientos veinte colonos adicionales.
                    <br>
                </p>

                <!--CEL-->
                <div class="row p2 menuWebPhone">

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/63748" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_051.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ascanio Schultze<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/53849" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_052.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Alfredo Gildemeister Prado y esposa<br>
                                        1900
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/19179" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_053.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Baronesa De Von Humbold<br>
                                        1921
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/54418" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_054.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Julie Wolff<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/5835" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_055.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Amanda Habegger<br>
                                        1881
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/7442" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_056.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Staudt<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/61387" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_057.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Celma Freundt<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/5032" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_058.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Schafer<br>
                                        1908
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/38044" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_059.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Otto Sattler Pflücker<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/10668" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_060.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Zimmermann<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/53822" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_061.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Ludowieg Schmidt y familia<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p-3">
                        <div class=" libro">
                            <a href="https://hdl.handle.net/20.500.14428/53979" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_062.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Aída Freundt Sáenz<br>
                                        1930
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/63748" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_051.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ascanio Schultze<br>
                                        1884
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/53849" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_052.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Alfredo Gildemeister Prado y esposa<br>
                                        1900
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/19179" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_053.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Baronesa De Von Humbold<br>
                                        1921
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/54418" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_054.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Julie Wolff<br>
                                        1883
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/5835" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_055.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Amanda Habegger<br>
                                        1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/7442" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_056.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Staudt<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/61387" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_057.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Celma Freundt<br>
                                        1891
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/5032" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_058.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Schafer<br>
                                        1908
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/38044" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_059.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Otto Sattler Pflücker<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/10668" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_060.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Sr. Zimmermann<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/53822" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_061.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Carlos Ludowieg Schmidt y familia<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/53979" target="_blank" style="color: black;">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio11/ET02-MS04-INM_062.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Aída Freundt Sáenz<br>
                                        1930
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12  mb-5 pb-3">
                        <p class="text-white fontMS500 font-24">
                            La composición de la sociedad peruana es diversa. La relación entre las distintas
                            comunidades transita entre la tensión y la integración, configurando una identidad compleja
                            enriquecida por múltiples aportes. Los inmigrantes y sus descendientes contribuyen
                            culturalmente a las comunidades donde se desarrollan, aunque este proceso no sea evidente
                            desde el inicio. En nuestro país, la comunidad china tuvo que soportar prejuicios,
                            discriminación y adversidades en un largo camino para su asimilación y hoy no se puede
                            pensar una identidad nacional sin su aporte.
                        </p>
                    </div>
                    <div class="col-sm-2">

                    </div>
                    <div class="col-sm-4">
                        <img class="img-fluid mb-3 " width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_dialogo2.jpg">

                    </div>
                    <div class="col-sm-4">
                        <img class="img-fluid mb-3 " width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_dialogo1.jpg">

                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-2">

                    </div>
                    <div class="col-sm-8">
                        <p class="fontMS100Italic text-center text-white">
                            Retratos de Ho Chin Choo por Adolphe Dubreuil, 1894

                        </p>
                    </div>
                    <div class="col-sm-2">

                    </div>
                    <!-- <div class="col-sm-3">
                        <p style="padding-top: 100%;" class="text-white fontMS500 font-24">
                            ¿Qué puede indicarnos que el ciudadano Ho Chin Choo se retratara vistiendo de manera tradicional y occidental? 

                        </p>
                        <img class="img_dialogoCol"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA_DIALOGO3.png">
                    </div> -->
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <!-- <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Qué puede indicarnos que el ciudadano Ho Chin Choo se retratará vistiendo de manera
                            tradicional y occidental?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div> -->
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Qué puede indicarnos que el ciudadano Ho Chin Choo se retratara vistiendo de manera
                            tradicional y occidental?
                        </p>
                        <img class="img_dialogoCol"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA_DIALOGO4.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cómo se puede mantener cohesionada una comunidad si sus integrantes son de orígenes
                            diversos?
                        </p>
                        <img class="img_dialogoCol"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA_DIALOGO4.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24 ">
                            ¿Los migrantes peruanos tienen un aporte positivo en los países donde se han establecido?
                        </p>
                        <img class="img_dialogoCol"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA_DIALOGO4.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio11\ET02-MS04-INM_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 font-22">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Bonfiglio Volpe, G. (1993) <br>
                            </span>
                            Los italianos en la sociedad peruana: una visión histórica. <br>
                            <span class="fontMS100">
                                Lima: Asociación Italianos del Perú. <br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=242353" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Carrasco, J.M. (2013)
                            </span><br>
                            Inmigrantes ingleses en Lima y el Callao en el siglo XIX. En: Nueva corónica 2 (julio) pp.
                            365-376. <br>
                            <span class="fontMS100">
                                Escuela de Historia UNMSM. <br>
                            </span>
                            <a href="https://www.researchgate.net/publication/341929896_Inmigrantes_ingleses_en_Lima_y_el_Callao_en_el_siglo_XIX"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Mc Evoy, G. (2018)
                            </span><br>
                            La experiencia invisible. Inmigrantes irlandeses en el Perú. <br>
                            <span class="fontMS100">
                                Lima: Fondo Editorial Universidad Nacional Mayor de San Marcos. <br>
                            </span>
                            <a href="https://fondoeditorial.unmsm.edu.pe/index.php/fondoeditorial/catalog/book/215"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">Organización Internacional para las Migraciones (OIM)</span>
                            <span class="fontMS100"> de las Naciones Unidas. Plataforma</span>
                            Soy migrante. <br>
                            <a href="https://iamamigrant.org/es" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Millies, D. (2007)
                            </span><br>
                            Echando raíces. 180 años de presencia alemana en el Perú.
                            <span class="fontMS100">
                                Lima: Instituto Cultural Peruano Norteamericano. <br>
                            </span>
                            <a href="https://fdocuments.es/document/echando-raices-presencia-alemana-5682806102231.html"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Riviale, P. (2008)
                            </span><br>
                            Una historia de la presencia francesa en el Perú, del siglo de las luces a los años locos.
                            <span class="fontMS100">
                                Lima: IFEA – Instituto de Estudios Peruanos – Fondo Editorial del Congreso del Perú –
                                Embajada de Francia en el Perú. <br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=350465" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Rodríguez Pastor, H. (2017)
                            </span><br>
                            Chinos en la sociedad peruana, 1820-2000: presencia, influencia y alcances.
                            <span class="fontMS100">
                                Lima: Universidad Nacional Mayor de San Marcos, Facultad de Ciencias Sociales, Fondo
                                Editorial. <br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=545888" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>